import { FormHeader, FormItem } from '@scts-ui/component-library';
import { Party } from '@scts/models';
import { standardDateFormatter } from '@scts/utilities';

export interface BasicProps {
  basicDetails: Party;
}

const Basic = (basicprops: BasicProps) => {
  return (
    <div className="d-flex flex-column flex-lg-row flex-wrap">
      <div className="card-body">
        <FormHeader detail={'Personal Details: '} />

        <FormItem
          header={'Name: '}
          detail={
            basicprops.basicDetails.firstName +
            ' ' +
            basicprops.basicDetails.lastName
          }
          minWidthHeader={'9.7rem'}
          minWidthDetail={'9.7rem'}
        />
        <FormItem
          header={'Date of Birth: '}
          detail={standardDateFormatter(
            new Date(basicprops.basicDetails.dateOfBirth)
          )}
          minWidthHeader={'9.7rem'}
          minWidthDetail={'9.7rem'}
        />
        <FormItem
          header={'National Insurance: '}
          detail={basicprops.basicDetails.nationalInsuranceNumber}
          minWidthHeader={'9.7rem'}
          minWidthDetail={'9.7rem'}
        />
      </div>
      <div className="card-body">
        <FormHeader detail={'Contact Details: '} />

        {basicprops.basicDetails.phoneNumbers.map((phoneNumber, index) => (
          <>
            <FormItem
              header={'Phone Number:'}
              detail={phoneNumber.number}
              minWidthHeader={'9.7rem'}
              minWidthDetail={'9.7rem'}
              key={index}
              isPhone={true}
            />
            <FormItem
              header={'Phone Type:'}
              detail={phoneNumber.phoneType}
              minWidthHeader={'9.7rem'}
              minWidthDetail={'9.7rem'}
              key={index}
            />
          </>
        ))}

        <FormItem
          header={'Email:'}
          detail={basicprops.basicDetails.emailAddress}
          minWidthHeader={'9.7rem'}
          minWidthDetail={'9.7rem'}
          isEmail={true}
        />
      </div>
    </div>
  );
};

export default Basic;
